import { bool, string } from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { SA_SELLER_ID } from 'shared/consts/checkout'
import {
  getPhoneNumber,
  getSelectedShippingAddressId,
  getShippingAddresses,
} from 'shared/store-checkout/duck/address'
import AddressListItem from 'views/components/organisms/Checkout/AddressListItem'
import './AddressList.scss'

const AddressListPropTypes = {
  sellerId: string.isRequired,
  subOrderId: string,
  allowChanges: bool,
}

const AddressListDefaultProps = {
  allowChanges: false,
  subOrderId: null,
}

const AddressList = ({ sellerId, subOrderId, allowChanges }) => {
  const addresses = useSelector(state => getShippingAddresses(state))
  const selectedAddress = useSelector(state =>
    getSelectedShippingAddressId(state, subOrderId)
  )

  const phoneNumber = useSelector(state => getPhoneNumber(state))

  const [selectedAddressId, setSelectedAddressId] = useState('')

  useEffect(() => {
    if (addresses && selectedAddressId === '') {
      setSelectedAddressId(selectedAddress)
    }
    // TODO for code owners: consider fixing and/or removing this line
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addresses])

  const allowedToShowPup = sellerId === SA_SELLER_ID

  return (
    <ul className="o-AddressList a-list-reset l-flex l-flex--vertical-center u-color--dark">
      {addresses.length &&
        addresses.map(entry => {
          const isPupAddress = Object.prototype.hasOwnProperty.call(
            entry,
            'pickupStation'
          )
          if (!isPupAddress || (isPupAddress && allowedToShowPup)) {
            return (
              <AddressListItem
                subOrderId={subOrderId}
                entry={entry}
                selectedAddressId={selectedAddressId}
                setSelectedAddressId={setSelectedAddressId}
                key={`${entry.id}-${subOrderId}`}
                allowChanges={allowChanges}
                existingPhoneNumber={phoneNumber}
              />
            )
          }
          return null
        })}
    </ul>
  )
}

AddressList.propTypes = AddressListPropTypes
AddressList.defaultProps = AddressListDefaultProps

export default AddressList
